import styled from 'styled-components';
import { spacing as spacingDefinitions } from '../styles';
export const Stack = styled.div `
  display: grid;
  ${({ orientation, equalHeights }) => orientation == 'horizontal'
    ? 'grid-auto-flow: column;'
    : equalHeights
        ? 'grid-auto-rows: 1fr;'
        : null}
      ${({ fullHeight }) => fullHeight && 'height: 100%;'}
      ${({ orientation, verticalAlign }) => {
    if (orientation == 'horizontal') {
        switch (verticalAlign) {
            case 'Top':
                return 'align-items: start;';
            case 'Bottom':
                return 'align-items: end;';
            default:
                return 'align-items: center;';
        }
    }
    else {
        switch (verticalAlign) {
            case 'Top':
                return 'align-content: start;';
            case 'Bottom':
                return 'align-content: end;';
            case 'Middle':
                return 'align-content: center;';
            default:
                return 'align-content: space-between;';
        }
    }
}}
      ${({ spacing = 'none' }) => `grid-gap: ${spacingDefinitions[spacing]};`}
`;
//# sourceMappingURL=Stack.js.map